module.exports = __webpack_public_path__ + "static/media/bo.313587a2.svg";